(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewingReport.controller:CrewingReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewingReport')
    .controller('CrewingReportCtrl', CrewingReportCtrl)
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	});

  function CrewingReportCtrl(CommonMasterData,RemoteService,$sce,MessageService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewingReportCtrl';

    //report types
    vm.reportTypes = {
    		SUMMARY : 'SUM',
    		DETAILED : 'DET',
    		NIGHT_FLIGHT_DISTRIBUTION : 'NFD',
        NIGHT_DEPARTURE : 'NDP'
    }

    vm.model = {
			searchPanelToggle : true,
      largeSearchPeriod : false,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				acType : null,
				crewBase : null,
				reportType : null
			},
			masterList : {
				crewTypeList : [],
				crewBaseList :[],
				aircraftTypes :[],
				fromDateAfterToDate : false,
				dateDiffMoreThanAMonth : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl :null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCrewingReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			if(flag === 'fromDate' || flag === 'toDate'){
				setDateValidationFlags();

				if(!!searchParams.fromDate && !!searchParams.toDate
						&& !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
					if (istoDateBeforeFromDate()) {
						vm.model.masterList.fromDateAfterToDate = true;
					}else{
						vm.model.masterList.fromDateAfterToDate = false;
						setDateDifMoreThanAMonthFlag();
					}
				}

			}else if(flag === 'reportType'){
				setDateDifMoreThanAMonthFlag();
			}

		};

		function setDateValidationFlags(){
			//if from date invalid
			if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
				vm.model.masterList.fromDateFormatInvalid = true;
				vm.model.masterList.fromDateAfterToDate = false;
			}else{
				vm.model.masterList.fromDateFormatInvalid = false;
			}

      vm.model.largeSearchPeriod = (getDatesDifference(
        vm.model.searchCriteria.fromDate,
        vm.model.searchCriteria.toDate) > 31) ? true : false;

			//if to date invalid
			if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
				vm.model.masterList.toDateFormatInvalid = true;
				vm.model.masterList.fromDateAfterToDate = false;
			}else{
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date){
			if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
				return true;
			}
			return false;
		}

		function setDateDifMoreThanAMonthFlag(){
			vm.model.masterList.fromDateAfterToDate = false;
			//this validation is applied only for detail report
			if(isDateRangeDifferenceMoreThanAMonth()){
				vm.model.masterList.dateDiffMoreThanAMonth = true;
			}else{
				vm.model.masterList.dateDiffMoreThanAMonth = false;
			}
		}

		function isDateRangeDifferenceMoreThanAMonth(){
			var from = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY");
			var to = moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY");
			var daysDif = to.diff(from, 'days');
			if(daysDif>=31){
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// load search electronic log book
		function searchCrewingReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;

				var type = getReportType(param.reportType);
        var isNewNight = false;
				var rptDesign = "";
				switch (type){
					case vm.reportTypes.SUMMARY :
						rptDesign = "crewing_summary.rptdesign";
						break;
					case vm.reportTypes.NIGHT_FLIGHT_DISTRIBUTION :
						rptDesign = "crewing_nit_flt_dist.rptdesign";
						break;
          case vm.reportTypes.NIGHT_DEPARTURE :
            rptDesign = "crewing_nit_flt_dist.rptdesign";
            isNewNight = true;
            break;
					default :
						rptDesign = "crewing_detail.rptdesign";
						break;
				}
        param.isNewNight = isNewNight;
        param.reportName = isNewNight ? 'Night Departure' : 'Night Flight Distribution';

				var dataMap = getSearchParamMap(param);
				var data = {
					pStartDate : dataMap["fromDate"],
					pEndDate : dataMap["toDate"],
					pCrewType : dataMap["crewType"],
					pAcType : dataMap["acType"],
					pBase : dataMap["crewBase"],
          pNight : dataMap["isNewNight"],
          pReportName : dataMap["reportName"]
				};

		    	var url = CommonLogicService.getReportUrl(rptDesign,data);
		    	vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		//set search param map
		function getSearchParamMap(param){
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["crewType"] = param.crewType.crewTypeCode;
			searchParamMap["reportType"] = getReportType(param.reportType);
			searchParamMap["acType"] = (!!param.aircraftType && !!param.aircraftType.modelNumber) ? param.aircraftType.modelNumber:'';
			searchParamMap["crewBase"] = (!!param.crewBase && !!param.crewBase.airPortCode) ? param.crewBase.airPortCode:'';
      searchParamMap["isNewNight"] = param.isNewNight ? 'Y' : 'N';
      searchParamMap["reportName"] = param.reportName;
			return searchParamMap;
		}

		//change vm.reportTypes json object according to the request parameters
		//currently set vm.reportTypes values as SUMMARY = 'SUM',DETAILED = 'DET',
		//and NIGHT_FLIGHT_DISTRIBUTION = 'NFD'
		function getReportType(reportType){
			if(reportType === null ){
				return vm.reportTypes.SUMMARY;
			}else if(reportType === 1){
				return vm.reportTypes.DETAILED;
			}else if(reportType === 2){
				return vm.reportTypes.NIGHT_FLIGHT_DISTRIBUTION;
			}else if(reportType === 3){
        return vm.reportTypes.NIGHT_DEPARTURE;
      }
		}

    function getDatesDifference(fromDate, toDate) {
      var diff = 0;
      if (!!fromDate && !!toDate) {
        diff = moment(toDate, "DD/MM/YYYY").diff(
          moment(fromDate, "DD/MM/YYYY"), 'days')
      }
      return diff;
    }

		//validate search Params
		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if(vm.model.masterList.fromDateFormatInvalid  || vm.model.masterList.toDateFormatInvalid){
				vm.model.masterList.fromDateAfterToDate = false;
				vm.model.masterList.dateDiffMoreThanAMonth = false;
				return false;
			}else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				vm.model.masterList.dateDiffMoreThanAMonth = false;
				return false;
			}else if(vm.model.searchCriteria.reportType !== null && !vm.model.searchCriteria.reportType &&
					isDateRangeDifferenceMoreThanAMonth()){
				vm.model.masterList.fromDateAfterToDate = false;
				vm.model.masterList.dateDiffMoreThanAMonth = true;
				return false;
			}
			vm.model.masterList.fromDateAfterToDate = false;
			vm.model.masterList.dateDiffMoreThanAMonth = false;
			return true;
		}

		//init loading
		(function() {
			//get crew types
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type list retrieval error');
			});

			// aircraft types
			CommonMasterData.getAircraftModelList(function(aircrafts) {
				vm.model.masterList.aircraftTypes = aircrafts;
			}, function() {
				console.log('Aircraft types retrieval error');
			});

			// base list
			CommonMasterData.getCrewBaseList(function(crewBases) {
				vm.model.masterList.crewBaseList = crewBases;
			}, function() {
				console.log('Crew Base List retrieval error');
			});

		})();
	}
}());
